import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { INLINES } from '@contentful/rich-text-types';

import css from './Topbar.module.scss';

const PreHeader = (props) => {
  const {
    preHeaderContentState
  } = props;

  if(!preHeaderContentState.data) {
    return null;
  }

  return (
    <div className={css.new}>
      {
        preHeaderContentState.data &&
        documentToReactComponents(preHeaderContentState.data.fields.preHeader, {
          renderNode: {
            [INLINES.HYPERLINK]: (node, children) => (
              <a href={node.data.uri} target="_blank" rel="noopener noreferrer">
                {children}
              </a>
            ),
          },
        })
      }
    </div>
  );
};

export default PreHeader;
